module.exports = __webpack_public_path__ + "static/media/aviation.22490300.png";